import { POST } from "../../APiHelper/API";

export const createNewCupAPI = (
    data,
    onSuccess,
    onError
) => {

    POST("/api/v1/cups/create", data, onSuccess, onError)
}